import script from "./template-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./template-preview.vue?vue&type=script&setup=true&lang=js"

import "./template-preview.vue?vue&type=style&index=0&id=2495344c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2495344c"]])

export default __exports__